import React, { useContext, useEffect, useState } from "react";
import HttpContext from "../../../../contexts/HTTP/HttpContext";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  FormControl,
  InputLabel,
  TextField,
  Autocomplete
} from "@mui/material";

const { KIOSKLOG_EVENTS } = require("./../../../../constants");

function SearchDropdown({ label, value, onChange }) {
  const [optionList, setOptionList] = useState(["Has Value", "No Value"]);
  const { get, post } = useContext(HttpContext);

  useEffect(() => {
    async function getDropLoc() {}

    getDropLoc();
  }, []);

  return (
    <div style={{ minWidth: "10rem" }}>
      <FormControl fullWidth>
        <Autocomplete
          disablePortal
          id="cbeventoptions"
          options={optionList}
          onChange={onChange}
          renderInput={params => (
            <TextField
              {...params}
              fullWidth
              variant="outlined"
              name="name"
              label={label}
            />
          )}
        />
      </FormControl>
    </div>
  );
}

export default SearchDropdown;
